import { Grid, Typography, Paper, Accordion, Button, Modal, Box, List, InputBase, Divider, AccordionSummary, AccordionDetails } from '@mui/material';
import { observer } from 'mobx-react';
import * as React from 'react';
import TaskGradeEditPageStore from '../store/TaskGradeEditStore';
import { QuestionModel } from 'domains/models/QuestionModel';
import { useMediaQueryState } from '../../../hooks/useMediaQueryState';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import CheckIcon from '@mui/icons-material/Check';
import saveIcon from '../../../assets/image/saveIcon.png';
import DeleteIcon from '@mui/icons-material/Delete';

import { styled } from '@mui/material/styles';

const StyledAccordion = styled(Accordion)(({ theme }) => ({
  '&::before': {
    display: 'none',
  },
  '& .MuiButtonBase-root .MuiAccordionSummary-root .Mui-expanded': {
    minHeight: '42px',
  },
  '& .MuiAccordionSummary-content': {
    margin: '0px',
  },
}));

const StyledButton = styled(Button)(({ theme, value }) => ({
  padding: 0,
  minWidth: '24px',
  height: '24px',
  textAlign: 'center',
  paddingTop: '4px',
  borderRadius: '50%',
  fontFamily: 'Pretendard',
  fontStyle: 'normal',
  fontWeight: 400,
  fontSize: '16px',
  lineHeight: '16px',
  marginLeft: '11px',
  color: 'black',
}));

interface Props {
  pageStore: TaskGradeEditPageStore;
  updateMode: boolean;
}
function TaskGradeEditBodyEssential(props: Props) {
  const { pageStore } = props;
  const { isPC } = useMediaQueryState();
  const [isExpanded, setIsExpanded] = React.useState<boolean>(false);
  const [isTextEdit, setIsTextEdit] = React.useState<boolean>(false);
  const [inputValue, setInputValue] = React.useState<string>('');

  const handleclickRating = (e: any, question: QuestionModel) => {
    console.log(e.target.value, question);
    pageStore.changeRating(e.target.value, question, props.updateMode);
  };

  const handleClickEditText = () => {
    setIsTextEdit(true);
  };

  const handleChangeInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    setInputValue(e.target.value);
  };

  const handelClickDelete = (e: React.MouseEvent, question: QuestionModel) => {
    e.stopPropagation();

    if (question.tempId) {
      pageStore.deleteTempQuestion(question.tempId);
    } else {
      if (!question.id) return;
      pageStore.deleteTempQuestion(question.id);
    }
  };

  function getRandomInt(max: number) {
    return Math.floor(Math.random() * max);
  }

  const handleClickSaveBtn = async () => {
    if (inputValue === '') return;
    setIsTextEdit(false);
    const doc: QuestionModel = {
      tempId: getRandomInt(10000000000).toString(),
      type: 'QUESTION',

      title: inputValue,
      status: 'DOING',
      subtype: 'CUSTOM',
      published: true,
      userData: {
        rating: 0,
      },
    };
    pageStore.createTempQuestion(doc);
    setInputValue('');
  };

  return (
    <>
      <Grid container justifyContent={'center'} style={{ width: '100%', marginTop: '40px' }}>
        <Grid item xs={11} style={isPC ? { justifyContent: 'center' } : {}}>
          <Typography
            style={{
              paddingTop: 5,

              fontWeight: 500,
              fontSize: '14px',
              lineHeight: '14px',
            }}
          >
            핵심가치 평가
          </Typography>
        </Grid>
        <Grid item xs={1} justifyContent={'flex-end'} style={{ cursor: 'pointer' }}>
          {isExpanded ? (
            <ExpandLessIcon
              onClick={() => {
                setIsExpanded(false);
              }}
              style={{
                color: '#2281D0',
              }}
            />
          ) : (
            <ExpandMoreIcon
              onClick={() => {
                setIsExpanded(true);
              }}
              style={{
                color: '#2281D0',
              }}
            />
          )}
        </Grid>
        <List dense sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}>
          {isExpanded ? (
            <Grid container>
              {pageStore.questionList?.map((question, index) => {
                return (
                  <StyledAccordion
                    key={index}
                    // expanded={
                    //   question.tempId
                    //     ? expanded === `panel${question.tempId}`
                    //     : expanded === `panel${question.id}`
                    // }
                    defaultExpanded
                    style={{
                      borderRadius: '10px',
                      marginBottom: '5px',
                      width: '100%',
                      boxShadow: 'none',
                      border: '1px solid #dddddd',
                      background: question.userData.rating ? '#2281D0' : 'white',
                    }}
                  >
                    <AccordionSummary aria-controls='panel1a-content' id='panel1a-header'>
                      <Grid container alignItems='center'>
                        <Grid item xs={10}>
                          <Typography
                            style={{
                              fontWeight: 500,
                              fontSize: '14px',
                              lineHeight: '14px',
                              color: question.status === 'COMPLETED' ? 'white' : 'black',
                            }}
                          >
                            {question.title}
                          </Typography>
                        </Grid>
                        <Grid item xs={1}>
                          {question.subtype === 'BASIC' ? (
                            ''
                          ) : (
                            <DeleteIcon
                              width='20px'
                              height='20px'
                              style={{
                                cursor: 'pointer',
                                color: question.status === 'COMPLETED' ? 'white' : '#2281D0',
                              }}
                              onClick={(e: React.MouseEvent) => handelClickDelete(e, question)}
                            />
                          )}
                        </Grid>
                        <Grid item xs={1} style={{ paddingTop: '10px' }}>
                          {question.subtype === 'BASIC' && question.status === 'COMPLETED' ? <CheckIcon style={{ color: 'white' }} width='20px' height='20px' /> : <></>}
                        </Grid>
                      </Grid>
                    </AccordionSummary>
                    <AccordionDetails style={{ position: 'relative', padding: '2% 3%' }}>
                      <Divider
                        style={{
                          border: '0.5px solid #eeeeee',
                          position: 'absolute',
                          top: '-8px',
                          left: 0,
                          width: '100%',
                        }}
                      />
                      <Grid
                        container
                        onClick={(e: any) => handleclickRating(e, question)}
                        style={{
                          cursor: 'pointer',
                          paddingLeft: '0',
                          justifyContent: 'center',
                        }}
                      >
                        <StyledButton
                          variant='outlined'
                          sx={{
                            border: question.userData?.rating === 1 ? '1px solid #dddddd' : question.status === 'COMPLETED' ? '1px solid #2281D0' : '1px solid #dddddd',
                            color: question.userData.rating ? 'white' : 'black',
                          }}
                          value={1}
                        >
                          1
                        </StyledButton>
                        <StyledButton
                          variant='outlined'
                          sx={{
                            border: question.userData?.rating === 2 ? '1px solid #dddddd' : question.status === 'COMPLETED' ? '1px solid #2281D0' : '1px solid #dddddd',
                            color: question.userData.rating ? 'white' : 'black',
                          }}
                          value={2}
                        >
                          2
                        </StyledButton>
                        <StyledButton
                          variant='outlined'
                          sx={{
                            border: question.userData?.rating === 3 ? '1px solid #dddddd' : question.status === 'COMPLETED' ? '1px solid #2281D0' : '1px solid #dddddd',
                            color: question.userData.rating ? 'white' : 'black',
                          }}
                          value={3}
                        >
                          3
                        </StyledButton>
                        <StyledButton
                          variant='outlined'
                          sx={{
                            border: question.userData?.rating === 4 ? '1px solid #dddddd' : question.status === 'COMPLETED' ? '1px solid #2281D0' : '1px solid #dddddd',
                            color: question.userData.rating ? 'white' : 'black',
                          }}
                          value={4}
                        >
                          4
                        </StyledButton>
                        <StyledButton
                          variant='outlined'
                          sx={{
                            border: question.userData?.rating === 5 ? '1px solid #dddddd' : question.status === 'COMPLETED' ? '1px solid #2281D0' : '1px solid #dddddd',
                            color: question.userData.rating ? 'white' : 'black',
                          }}
                          value={5}
                        >
                          5
                        </StyledButton>
                        <StyledButton
                          variant='outlined'
                          sx={{
                            border: question.userData?.rating === 6 ? '1px solid #dddddd' : question.status === 'COMPLETED' ? '1px solid #2281D0' : '1px solid #dddddd',
                            color: question.userData.rating ? 'white' : 'black',
                          }}
                          value={6}
                        >
                          6
                        </StyledButton>
                        <StyledButton
                          variant='outlined'
                          sx={{
                            border: question.userData?.rating === 7 ? '1px solid #dddddd' : question.status === 'COMPLETED' ? '1px solid #2281D0' : '1px solid #dddddd',
                            color: question.userData.rating ? 'white' : 'black',
                          }}
                          value={7}
                        >
                          7
                        </StyledButton>
                      </Grid>
                    </AccordionDetails>
                  </StyledAccordion>
                );
              })}
              {pageStore.customQuestionList?.map((question, index) => {
                return (
                  <StyledAccordion
                    key={index}
                    // expanded={expanded === `panel${question.tempId}`}
                    defaultExpanded
                    style={{
                      borderRadius: '10px',
                      marginBottom: '5px',
                      width: '100%',
                      boxShadow: 'none',
                      border: '1px solid #dddddd',
                      background: question.userData.rating ? '#2281D0' : 'white',
                    }}
                  >
                    <AccordionSummary aria-controls='panel1a-content' id='panel1a-header'>
                      <Grid container justifyContent={'space-between'}>
                        <Typography
                          style={{
                            fontWeight: 500,
                            fontSize: '14px',
                            lineHeight: '14px',
                            color: question.status === 'COMPLETED' ? 'white' : 'black',
                          }}
                        >
                          {question.title}
                        </Typography>
                        {question.subtype === 'BASIC' ? (
                          ''
                        ) : (
                          <DeleteIcon
                            width='20px'
                            height='20px'
                            style={{
                              cursor: 'pointer',
                              color: question.status === 'COMPLETED' ? 'white' : '#2281D0',
                            }}
                            onClick={(e: React.MouseEvent) => handelClickDelete(e, question)}
                          />
                        )}
                      </Grid>
                    </AccordionSummary>
                    <AccordionDetails style={{ position: 'relative' }}>
                      <Divider
                        style={{
                          border: '0.5px solid #eeeeee',
                          position: 'absolute',
                          top: '-8px',
                          left: 0,
                          width: '100%',
                        }}
                      />
                      <Grid
                        container
                        onClick={(e: any) => handleclickRating(e, question)}
                        style={{
                          cursor: 'pointer',
                          paddingLeft: '0',
                          justifyContent: 'center',
                        }}
                      >
                        <StyledButton
                          variant='outlined'
                          sx={{
                            border: question.userData?.rating === 1 ? '1px solid #dddddd' : question.status === 'COMPLETED' ? '1px solid #2281D0' : '1px solid #dddddd',
                            color: question.userData.rating ? 'white' : 'black',
                          }}
                          value={1}
                        >
                          1
                        </StyledButton>
                        <StyledButton
                          variant='outlined'
                          sx={{
                            border: question.userData?.rating === 2 ? '1px solid #dddddd' : question.status === 'COMPLETED' ? '1px solid #2281D0' : '1px solid #dddddd',
                            color: question.userData.rating ? 'white' : 'black',
                          }}
                          value={2}
                        >
                          2
                        </StyledButton>
                        <StyledButton
                          variant='outlined'
                          sx={{
                            border: question.userData?.rating === 3 ? '1px solid #dddddd' : question.status === 'COMPLETED' ? '1px solid #2281D0' : '1px solid #dddddd',
                            color: question.userData.rating ? 'white' : 'black',
                          }}
                          value={3}
                        >
                          3
                        </StyledButton>
                        <StyledButton
                          variant='outlined'
                          sx={{
                            border: question.userData?.rating === 4 ? '1px solid #dddddd' : question.status === 'COMPLETED' ? '1px solid #2281D0' : '1px solid #dddddd',
                            color: question.userData.rating ? 'white' : 'black',
                          }}
                          value={4}
                        >
                          4
                        </StyledButton>
                        <StyledButton
                          variant='outlined'
                          sx={{
                            border: question.userData?.rating === 5 ? '1px solid #dddddd' : question.status === 'COMPLETED' ? '1px solid #2281D0' : '1px solid #dddddd',
                            color: question.userData.rating ? 'white' : 'black',
                          }}
                          value={5}
                        >
                          5
                        </StyledButton>
                        <StyledButton
                          variant='outlined'
                          sx={{
                            border: question.userData?.rating === 6 ? '1px solid #dddddd' : question.status === 'COMPLETED' ? '1px solid #2281D0' : '1px solid #dddddd',
                            color: question.userData.rating ? 'white' : 'black',
                          }}
                          value={6}
                        >
                          6
                        </StyledButton>
                        <StyledButton
                          variant='outlined'
                          sx={{
                            border: question.userData?.rating === 7 ? '1px solid #dddddd' : question.status === 'COMPLETED' ? '1px solid #2281D0' : '1px solid #dddddd',
                            color: question.userData.rating ? 'white' : 'black',
                          }}
                          value={7}
                        >
                          7
                        </StyledButton>
                      </Grid>
                    </AccordionDetails>
                  </StyledAccordion>
                );
              })}

              <Grid container style={{ justifyContent: 'center' }}>
                {isTextEdit ? (
                  <Paper
                    component='form'
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      width: '100%',
                      boxShadow: 'unset',
                      border: '1px solid #dddddd',
                      borderRadius: '10px',
                    }}
                  >
                    <InputBase
                      sx={{
                        minHeight: '42px',
                        fontWeight: 500,
                        fontSize: '14px',
                        lineHeight: '14px',
                        paddingLeft: '16px',
                      }}
                      value={inputValue}
                      onChange={handleChangeInput}
                    />
                    <img src={saveIcon} width='20px' height='20px' style={{ position: 'absolute', cursor: 'pointer', right: 10, bottom: 21 }} onClick={handleClickSaveBtn} alt='saveIcon' />
                  </Paper>
                ) : (
                  <Typography
                    style={{
                      fontWeight: 400,
                      fontSize: '14px',
                      lineHeight: '14px',
                      color: '#6C6B6F',
                      cursor: 'pointer',
                      background: '#f7f7f7',
                      borderRadius: '10px',
                      padding: '13px 16px',
                    }}
                    onClick={handleClickEditText}
                  >
                    +직접입력
                  </Typography>
                )}
              </Grid>
            </Grid>
          ) : (
            <></>
          )}
        </List>
      </Grid>
    </>
  );
}

export default observer(TaskGradeEditBodyEssential);
